import { render, staticRenderFns } from "./SampleJJ.vue?vue&type=template&id=3b8d60cb&scoped=true"
import script from "./SampleJJ.vue?vue&type=script&lang=js"
export * from "./SampleJJ.vue?vue&type=script&lang=js"
import style0 from "./SampleJJ.vue?vue&type=style&index=0&id=3b8d60cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8d60cb",
  null
  
)

export default component.exports